// extracted by mini-css-extract-plugin
export default {"main":"OmoEuiv_yOqhSbNuG3Wd"};